// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../../types';

import gql from 'graphql-tag';
export type BestLayoutProposalFragment = { __typename?: 'Proposal', space: { __typename?: 'SelfServeSpace', spatialConfigurations?: Array<{ __typename?: 'SelfServeSpatialConfiguration', name?: string | null, capacity?: number | null }> | null } };

export type BestLayoutSelfServeSpatialConfigurationFragment = { __typename?: 'SelfServeSpatialConfiguration', name?: string | null, capacity?: number | null };

export const BestLayoutSelfServeSpatialConfigurationFragmentDoc = gql`
    fragment BestLayoutSelfServeSpatialConfiguration on SelfServeSpatialConfiguration {
  name
  capacity
}
    `;
export const BestLayoutProposalFragmentDoc = gql`
    fragment BestLayoutProposal on Proposal {
  space {
    spatialConfigurations {
      ...BestLayoutSelfServeSpatialConfiguration
    }
  }
}
    ${BestLayoutSelfServeSpatialConfigurationFragmentDoc}`;